<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        dark
        class="my-1 text-none"
        v-bind="attrs"
        v-on="on"
        rounded
      >
        <v-icon left> mdi-plus </v-icon>
        Nueva Página
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-body-1 primary--text">Nueva Página</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <validation-alert :validationErrors="validationErrors" />
          <v-form ref="form" v-model="isValidFormDialog" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="editedItem.application"
                  :items="applications"
                  :rules="applicationRules"
                  item-text="name"
                  item-value="id"
                  label="Aplicación"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="editedItem.module"
                  v-if="editedItem.application"
                  :items="modules"
                  :rules="moduleRules"
                  item-text="name"
                  item-value="id"
                  label="Módulo"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.name"
                  :rules="nameRules"
                  label="Nombre"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="editedItem.description"
                  :rules="descriptionRules"
                  name="description"
                  label="Descripción"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey lighten-1" text @click="close()"> Cancelar </v-btn>
        <v-btn
          color="blue darken-1"
          :loading="isLoading"
          :disabled="isLoading"
          @click="save()"
          text
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ValidationAlert from "@/components/global/ValidationAlert.vue";
import { $EventBus } from "@/main";
export default {
  name: "CreatePageDialog",

  props: {},

  data: () => ({
    dialog: false,
    isLoading: false,
    isValidFormDialog: false,
    applicationRules: [(v) => !!v || "Campo requerido"],
    moduleRules: [(v) => !!v || "Campo requerido"],
    nameRules: [(v) => !!v || "Campo requerido"],
    descriptionRules: [(v) => !!v || "Campo requerido"],
    editedItem: {
      application: "",
      module: "",
      name: "",
      description: "",
      active: true,
    },
    defaultItem: {
      application: "",
      module: "",
      name: "",
      description: "",
      active: true,
    },
  }),

  computed: {
    applications() {
      return this.$store.getters["applications/getApplicationsList"];
    },
    modules() {
      return this.$store.getters["modules/getModulesList"];
    },
    validationErrors() {
      return this.$store.getters["pages/getValidationErrors"];
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
      if (val) {
        this.$store.dispatch("applications/getApplicationsList");
      }
    },
    "editedItem.application"() {
      this.listenApplication();
    },
  },

  methods: {
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.$store.dispatch("pages/cleanValidationErrors");
        this.$refs.form.resetValidation();
      });
    },

    showSnack(color = "", text = "") {
      $EventBus.$emit("showSnack", { color, text });
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        try {
          let data = {
            name: this.editedItem.name,
            description: this.editedItem.description,
            module_id: this.editedItem.module,
          };
          await this.$store.dispatch("pages/savePage", data);
          this.showSnack("green", "Se ha registrado satisfactoriamente");
          this.close();
        } catch (error) {}
        this.isLoading = false;
        this.$emit('resetFilter');
      }
    },

    listenApplication() {
      this.editedItem.module = null;
      this.$store.dispatch("modules/getModulesList", {
        app_id: this.editedItem.application,
      });
    },
  },
  components: {
    ValidationAlert,
  },
};
</script>
